(function () {
  'use strict';
  var nav = document.getElementById('nav');
  var menuBtn = document.getElementById('menuBtn');

  function subs() { return Array.prototype.slice.call(document.querySelectorAll('.has-sub')); }
  function closeSubs() {
    subs().forEach(function (li) {
      li.classList.remove('open');
      var b = li.querySelector('.sub-btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function closeAll() {
    closeSubs();
    if (nav) nav.classList.remove('open');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var sb = t.closest('.sub-btn');
    if (sb) {
      var li = sb.parentNode;
      var open = !li.classList.contains('open');
      closeSubs();
      li.classList.toggle('open', open);
      sb.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (t.closest('#menuBtn') && nav) {
      var o = !nav.classList.contains('open');
      nav.classList.toggle('open', o);
      menuBtn.setAttribute('aria-expanded', o ? 'true' : 'false');
      return;
    }
    if (!t.closest('.has-sub')) closeSubs();
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  // Contact : ?sujet=Création sur mesure présélectionne le sujet
  try {
    var wanted = new URLSearchParams(window.location.search).get('sujet');
    var sel = document.getElementById('contact-sujet');
    if (wanted && sel) {
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value === wanted || sel.options[i].text === wanted) { sel.selectedIndex = i; break; }
      }
    }
  } catch (err) { /* sans effet */ }
})();

/* Défilement gâteau / moule */
document.addEventListener('click', function (e) {
  var b = e.target.closest ? e.target.closest('.sl-btn') : null;
  if (!b) return;
  var sl = b.closest('.slider'), pr = sl.querySelector('.pair');
  pr.scrollBy({ left: (b.classList.contains('sl-next') ? 1 : -1) * pr.clientWidth, behavior: 'smooth' });
});
document.addEventListener('scroll', function (e) {
  var t = e.target;
  if (!t.classList || !t.classList.contains('pair')) return;
  var i = Math.round(t.scrollLeft / Math.max(t.clientWidth, 1));
  var sl = t.closest('.slider');
  sl.setAttribute('data-i', i);
  sl.setAttribute('data-end', i >= sl.querySelectorAll('figure').length - 1 ? '1' : '0');
  Array.prototype.forEach.call(sl.querySelectorAll('.dots i'), function (d, k) { d.classList.toggle('on', k === i); });
}, true);
